/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_AppInputs */

const en_us2_profile_why_app = /** @type {(inputs: Profile_Why_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme, language and units.`)
};

const pt_br2_profile_why_app = /** @type {(inputs: Profile_Why_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema, idioma e unidades.`)
};

const es_419_profile_why_app = /** @type {(inputs: Profile_Why_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema, idioma y unidades.`)
};

const pt_pt2_profile_why_app = /** @type {(inputs: Profile_Why_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema, idioma e unidades.`)
};

const fr_fr2_profile_why_app = /** @type {(inputs: Profile_Why_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thème, langue et unités.`)
};

const de_de2_profile_why_app = /** @type {(inputs: Profile_Why_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design, Sprache und Einheiten.`)
};

const it_it2_profile_why_app = /** @type {(inputs: Profile_Why_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tema, lingua e unità.`)
};

/**
* | output |
* | --- |
* | "Theme, language and units." |
*
* @param {Profile_Why_AppInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_app = /** @type {((inputs?: Profile_Why_AppInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_AppInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_app(inputs)
	if (locale === "es-419") return es_419_profile_why_app(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_app(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_app(inputs)
	if (locale === "de-DE") return de_de2_profile_why_app(inputs)
	if (locale === "it-IT") return it_it2_profile_why_app(inputs)
	return en_us2_profile_why_app(inputs)
});
export { profile_why_app as "profile.why_app" }